import axios from '@/utils/api'
import { SET_PROCESSO } from '../../../mutation-types'

const state = {
  processo: {}
}

const getters = {
  processo: state => state.processo
}

const mutations = {
  [SET_PROCESSO] (state, processo) {
    state.processo = processo
  }
}

const actions = {

  async getProcessoByProtocoloAndVersao ({ commit }, data) { // eslint-disable-line
    const processo = await axios(
      {
        method: 'GET',
        url: `processo/withCadastro/${data.protocolo}/${data.versao}`
      })
    processo.dadosCadastro = JSON.parse(processo.dadosCadastro)
    commit('SET_PROCESSO', processo)
    return processo
  },

  async getVersoesByProtocolo ({ commit }, protocolo) { // eslint-disable-line
    const versoes = await axios(
      {
        method: 'GET',
        url: 'processo/versoesCadastro/' + protocolo
      })
    return versoes
  },

  async credenciarProcesso ({ commit }, data) { // eslint-disable-line
    const resposta = await axios(
      {
        method: 'POST',
        url: `processo/credenciar/${data.idProcesso}`
      })

    return resposta
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
